let token = null;

export const adminSession = {
  get: () => token,
  set: (t) => { token = t; },
  clear: () => { token = null; },
};
